import axiosInstance from "@/plugins/axios.js";

export const getProducts = async (stockId, pageNumber,pageSize,search) => {
    try {
        const response = await axiosInstance.get("/UserStock", {
          params: {
            stockId: stockId,
            pageNumber: pageNumber,
            pageSize: pageSize,
            search: search,
          },
        });

        return response.data;

      } catch (error) {
        throw error;
      }
  };


  export const createStock = async (stockName) => {
    try {
        await axiosInstance.post(`/UserStock/CreateStock?stockName=${stockName}`);
        
      } catch (ex) {
        const errorMessage = ex.response?.data?.message || "Une erreur est survenue.";
        snackbarService.showSnackbar(errorMessage, "red");
      }
  };

  export const GetStocks = async () => {
    try {
        var response = await axiosInstance.get(`/UserStock/GetStock`);
        return response.data;
      } catch (error) {
        throw error;
      }
  };

    

    export const AddToStock = async (newStocks = {}) => {
        try {
            await axiosInstance.post("/UserStock/AddUserStock", newStocks);
          } catch (error) {
            throw error;
          }
      };

      export const UpdateStock = async (updatedStocks = {}) => {
        try {
            await axiosInstance.put("/UserStock/UpdateUserStock", updatedStocks);
          } catch (error) {
            throw error;
          }
      };